import { Globe as Globe2, Gauge, Network, Award, Zap, Factory, Building2, Leaf, Share2, Car, Waves, Boxes, Activity, Building, CircuitBoard, Radio, Cpu, ListFilter as Filter, ShieldCheck, BadgeCheck, TrendingUp, TrendingDown, Landmark, Users, FileText, CalendarClock, MapPin, Phone, Mail, Linkedin, ArrowRight, Play, ChevronDown, Menu, X, ExternalLink, Newspaper, PlugZap, BatteryCharging } from "lucide-react";

const iconMap = {
  Globe2, Gauge, Network, Award, Zap, Factory, Building2, Leaf, Share2, Car, Waves,
  Boxes, Activity, Building, CircuitBoard, Radio, Cpu, Filter, ShieldCheck, BadgeCheck,
  TrendingUp, TrendingDown, Landmark, Users, FileText, CalendarClock, MapPin, Phone, Mail,
  Linkedin, ArrowRight, Play, ChevronDown, Menu, X, ExternalLink, Newspaper, PlugZap,
  BatteryCharging
};

export const getIcon = (name) => iconMap[name] || Zap;

export default iconMap;
